<template>
  <div class="dashboard">
    <div class="banner">
      <img
        class="banner__img"
        src="@/assets/banner-logo.png"
        alt="banner-logo"
      />
      <p class="banner__text">Invision360 EHCP Quality Assurance Tool</p>

      <p class="banner__text current-review" :style="showInternalId">
        <span class="audit-text">Currently Auditing Review ID:</span>
        {{ internalId }}
      </p>
      <div class="banner_logout_wrapper">
        <NotificationsBanner />
        <div class="logout" @click="logout">
          <i class="fas fa-sign-out-alt fa-2x"></i>
        </div>
      </div>
    </div>
    <div class="main">
      <SideBar
        :touched="dirtySection"
        @click="didClickSideBar"
        @nav-clicked="didClickSideBar"
      />
      <span class="vertical-rule"></span>
      <TopNav @click="didClickSideBar" />
      <div class="content-container">
        <router-view
          :key="$route.fullPath"
          @content-updated="contentUpdated"
          @content-saved="contentSaved"
        />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import SideBar from '@/components/Nav/SideBar.vue'
import TopNav from '@/components/Nav/TopNav.vue'
import Footer from '@/components/Footer.vue'
import { mapActions, mapGetters } from 'vuex'
import NotificationsBanner from '@/components/Shared/NotificationsBanner.vue'

export default {
  name: 'Dashboard',
  components: { SideBar, TopNav, Footer, NotificationsBanner },
  data() {
    return {
      dirtySection: []
    }
  },
  computed: {
    ...mapGetters({
      currentAssignment: 'assignment/currentAssignment'
    }),
    dirtySections() {
      return this.dirtySection.length
        ? Array.from(new Set(this.dirtySection))
            .map(s => s.toUpperCase())
            .join(', ')
        : false
    },
    showInternalId() {
      if (
        this.$route.name === 'Section' ||
        this.$route.name === 'Audit Summary'
      ) {
        return {
          display: 'block'
        }
      }
      return {
        display: 'none'
      }
    },
    showTopBanner() {
      if (
        this.$route.name === 'Section' ||
        this.$route.name === 'Audit Summary'
      ) {
        return {
          display: 'none'
        }
      }
      return {
        display: 'block',
        height: '100%'
      }
    },
    showUnderBanner() {
      if (
        this.$route.name === 'Section' ||
        this.$route.name === 'Audit Summary'
      ) {
        return {
          display: 'block'
        }
      }
      return {
        display: 'none'
      }
    },
    internalId() {
      return this.currentAssignment
        ? this.currentAssignment.planId.internalId
        : ''
    }
  },
  methods: {
    ...mapActions({ _logout: 'user/logout' }),
    logout() {
      this._logout()
      return this.$router.push('/login')
    },
    didClickSideBar(event) {
      if (this.dirtySections) {
        alert(
          `You have made changes in section ${this.dirtySections}. Please click 'Next Section' in section ${this.dirtySections} to save these changes.`
        )
      }
    },
    contentUpdated(section) {
      if (!this.dirtySection.includes(section.id)) {
        this.dirtySection.push(section.id)
      }
    },
    contentSaved(section) {
      this.dirtySection = this.dirtySection.filter(s => s !== section.id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';
@import '@/style/dashboard.scss';

.audit-text {
  font-weight: 100 !important;
}
</style>
